import { useCharacters } from "../../../contexts/Characters"
import { useModal } from "../../../contexts/Modal"

const EventParticipants = () => {
    const modal = useModal()
    const characters = useCharacters()

    return (
        <ul className="d-flex">
            {modal.$state.data.participants.map((character) => (
                <li key={character._id}>
                    <span className={`chip ${character._id === characters.$state.current._id ? 'primary' : 'base'} mr-2 mb-2`}>{character.name}</span>
                </li>
            ))}
        </ul>
    )
}

export default EventParticipants